import React, { Component } from "react";
import {
  CardWrapper,
  Thumbnail,
  ThumbnailLayer,
  ContentContainer,
  DateText,
  TitleWrap,
  DateWrap,
  FooterContainer,
  ProgressInfoContainer,
  ProgressInfoText,
  PlayButton,
  ThumbnailWrap,
  RenderIngIcon,
} from "./ShortsCard.style";
import {connect} from 'react-redux';
import i18n from '@/i18n';
import dayjs from 'dayjs';
import { SHORTS_RENDER_STATE } from '@/utils/Global';

const clamp = (num, min, max) => Math.min(Math.max(num, min), max);

class Card extends Component {

  getContext = (layered, progress) => {
    const { video } = this.props

    // 편집중
    if (layered.state === SHORTS_RENDER_STATE.EMPTY) return this.renderEmptyState(i18n.t("myvideo.empty.text")) 

    // 렌더링 대기중
    if (layered.state === SHORTS_RENDER_STATE.WAITING) return this.renderWaitingState(i18n.t("myvideo.waiting.text"))
 
    // 오류/실패
    if (layered.state === SHORTS_RENDER_STATE.ERROR) return this.renderErrorState(layered.text)
    
    if (layered.state === SHORTS_RENDER_STATE.RENDERING) {
      // const renderStatus = progress ? progress.renderStatus : null

      // // 인코딩중
      // if (renderStatus === "MERGE" || renderStatus === "NONE") {
      //   return this.renderEncodingState(i18n.t("myvideo.encoding.text") + " ..")
      // }

      // let text = i18n.t("myvideo.ready.text") // 렌더링 준비중
      // let percentageText = ''
      // if (renderStatus === "ENERATE_YOUTUBE_SHORTS") {
      //   let percentage = progress ? progress.renderedPercentage * 100 : 0
      //   if (percentage > 70) {
      //     text = i18n.t("myvideo.preview.text") // 미리보기 생성중 71~100%
      //     const value = ((percentage / 100) * 70).toFixed(0)
      //     percentageText = `${clamp(30 + Number(value), 70, 100)}%`
      //   }
      //   else if (percentage > 0) {
      //     text = i18n.t("myvideo.rendering.text") // 렌더링중 31~70%
      //     const value = ((percentage / 100) * 70).toFixed(0)
      //     percentageText = `${clamp(30 + Number(value), 30, 100)}%`
      //   }
      //   else if (progress && video && video.setStateDate) {
      //     const seconds = (new Date() - new Date(video.setStateDate)) / 1000
      //       // VM의 renderStatus가 VIDEO가 되고 처음 10초동안 '렌더링 준비중' 상태
      //       // 10초 이후 부터 70초까지 '렌더링중 0~30%'
      //       if (seconds > 10) {
      //         text = i18n.t("myvideo.rendering.text")
      //         percentageText = `${clamp(((seconds - 10) / 2).toFixed(0), 0, 30)}%`
      //       }
      //   }
      // }

      // return this.renderRenderingState(text + " .. ", percentageText)
      return this.renderRenderingState(i18n.t("myvideo.rendering.text") + " .. ")
    }

    return null;
  }
  
  renderEmptyState = (text) => {
    return (
        <>
          <img src="https://front.videomonster.com/images-7cuytg20/web/v2/projectState/editing.svg" alt="editIcon"></img>
          <div>
            <div style={{ color: "#FFE17F" }}>{text}</div>
          </div>
        </>
      )
  }

  renderWaitingState = (text) => {
    return (
      <>
        <img src="https://front.videomonster.com/images-7cuytg20/web/v2/projectState/waiting.svg" alt="waitingIcon"></img>
        <div>
          <div style={{ color: "#FEAE3F" }}>{text}</div>
        </div>
      </>
    )
  }

  renderRenderingState = (text, percentageText) => {
    return (
      <>
        <img className="anim-rendering-icon" src="https://front.videomonster.com/images-7cuytg20/web/v2/projectState/rendering.svg" alt="errorIcon" ></img>
        <div style={{display:"flex"}}>
          <div style={{ color: "#1FBDCB" }}>{text}{percentageText}</div>
        </div>
      </>
    )
  }

  renderEncodingState = (text) => {
    return ( // 인코딩중
      <>
        <img style={{ marginBottom: "2px" }} src="https://front.videomonster.com/images-7cuytg20/web/v2/projectState/encoding.svg" alt="errorIcon" ></img>
        <div>
          <div style={{ color: "#1FBDCB" }}>{text}</div>
        </div>
      </>
    )
  }

  renderErrorState = (text) => {
    return (
      <>
        <img src="https://front.videomonster.com/images-7cuytg20/web/v2/projectState/error.svg" alt="errorIcon" ></img>
        <div style={{ color: "#FE3F3F" }}>{text}</div>
      </>
    )
  }
  handelChangeTitle = () => {
    const { onChangeTitle, video } = this.props;
    const state  = video.state
    
    if (state === "Empty" || state === "Error" || state === "Finish") return onChangeTitle(video)
  }
  renderPaymentText = () => {
    const { video, paymentInfo, isExistPayment, isProviderCafe24 = false, bundleCouponInfo } = this.props
    const isNoPayment = (paymentInfo && paymentInfo.isNoPayment)

    // 카페 24인 경우
    if (isProviderCafe24) {
      // 번들 결제하여 얻은 쿠폰 개수 입력
      const bundleCouponCount = bundleCouponInfo ? bundleCouponInfo.restCount : 0

      // 정기 결제 유저가 아닌 경우 + 번들결제하여 만료 기간이 있을 때
      if (video.isEditable && !isExistPayment && paymentInfo && paymentInfo.expiredAt) return `~${dayjs(paymentInfo.expiredAt).format("YY.MM.DD")}`
      // 편집 가능한 상태 (서버에서 판단하여 보내주는 값)
      if (video.isEditable) return
      // 쿠폰을 보유한 경우
      if (bundleCouponCount > 0) return "(1회차감)"
      // 정기결제를 해지한 경우
      return "(결제필요)"
    }

    // 비디오몬스터인 경우 (미결제 유저가 저장한 영상)
    if (isNoPayment && !isExistPayment) return `(${i18n.t("web.myvideo.free")})`
    
  }
  renderExpiredState = (expiredAt) => {
    if (!expiredAt) return null

    const expiredDate = new Date(expiredAt)
    const today = new Date()
    const gap = expiredDate.getTime() - today.getTime()
    const gapDay = gap / (1000 * 60 * 60 * 24)
    if (gapDay > 7) return null
    else if (gapDay > 1) return <div className="storeExpire">{i18n.t("myvideo.store-expired.alert").replace('{GAP}', Math.ceil(gapDay))}</div>
    else if (gapDay > 0) return <div className="storeExpire">{i18n.t("myvideo.store-expired.alert").replace('{GAP}', 1)}</div>
    else return <div className="storeExpire">{i18n.t("myvideo.store-expired")}</div>
}
  render() {
    const {
      thumbnailUrl,
      title,
      date,
      footerComponent,
      onThumbnailClicked,
      layered,
      progress,
      myvideo,
      video,
      value,
      isProviderCafe24,
      settingIcon
    } = this.props;

    let splitedDate = []
    let year = ''
    let month = ''
    let day = ''
    if(date) {
      splitedDate = date.split('.')
      if(splitedDate.length > 2) {
        year = splitedDate[0]
        month = splitedDate[1]
        day = splitedDate[2]
      }
    }
    
    let storeExpireAt = null
    if (!isProviderCafe24) storeExpireAt = video && video.storeExpireAt ? video.storeExpireAt : null

    const isLayered = layered ? true : false;
    const isFinished = layered && layered.state === "Finish" ? true : false;
    const isEmpty = layered && layered.state === "Empty" ? true : false;
    const isRendering = layered && layered.state === "Rendering" ? true : false;
    return (
      <CardWrapper>
        <ThumbnailWrap notThumbnailUrl = {!thumbnailUrl} onClick={isLayered ? onThumbnailClicked : null}>
          <ThumbnailLayer
            isFinished={isFinished}
            isLayered={isLayered}
            isEmpty={isEmpty}
            isRendering={isRendering}
          >
            <ProgressInfoContainer 
              isFinished={isFinished}
              isEmpty={isEmpty}
              backgroundColor={"#424242"}
              position = {(layered && layered.state === "Rendering")}
            >
              {/* {this.renderIcon()} */}
              {/* {isLayered && layered.iconUrl ? layered.iconUrl : null} */}
              <ProgressInfoText>
                {(isLayered && this.getContext(layered, progress)) || ""}
              </ProgressInfoText>
            </ProgressInfoContainer>
            <PlayButton isFinished={isFinished} />
          </ThumbnailLayer>
          <Thumbnail
            src={thumbnailUrl ? thumbnailUrl : ""}
            onClick={isLayered ? null : onThumbnailClicked}
            notThumbnailUrl = {!thumbnailUrl}
          />
        </ThumbnailWrap>
        {
          myvideo && 
          <ContentContainer isExistFooter={footerComponent ? true : false}>
            <TitleWrap >
              <div onClick={this.handelChangeTitle} style={isProviderCafe24 ? { maxWidth: "70%" } : {}}>
                <span>{title}</span>
                <img src="https://front.videomonster.com/images-7cuytg20/web/myvideo/invalid-name.svg" alt="" />
              </div>
              <span>{this.renderPaymentText()}</span>
            </TitleWrap>
            <DateWrap>
              <DateText>{`${year}.${month}.${day}`}</DateText>
              { this.renderExpiredState(storeExpireAt) }
            </DateWrap>
            {settingIcon && settingIcon}
          </ContentContainer>
        }
        { footerComponent && <FooterContainer>{footerComponent}</FooterContainer> }
      </CardWrapper>
    );
  }
}

const mapStateToProps = state => ({
  value: state.langStore.lang
})

export default connect(
  mapStateToProps,
  null
)(Card)